import { z } from "zod";

/**
 * Adds password confirmation validation to a schema.
 * Requires the schema to have `password` and `confirmPassword` fields.
 *
 * @example
 * const schema = withPasswordConfirmation(z.object({
 *   password: passwordField,
 *   confirmPassword: confirmPasswordField,
 * }));
 */
export const withPasswordConfirmation = <
  T extends z.ZodType<{ password: string; confirmPassword: string }>
>(
  schema: T
) =>
  schema.refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

